module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bot-75c0068ef23975847b91a43afc532735.svg";